import React from "react";
import { TableRow, TableCell, styled } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import { formatMetric } from "../../utils/metricUtils";
import { cruxyColors } from "../../theme/color-palette";
import { HeadroomTotals } from "@/graphql/types/graphql";
import { truncate } from "lodash";

interface HeadroomTableTotalsRowProps {
  totals?: HeadroomTotals;
}

const HeadroomTableTotalsRow: React.FC<HeadroomTableTotalsRowProps> = ({ totals }) => {
  if (!totals) return null;

  return (
    <TableRow>
      <Cell align="center">-</Cell>
      <Cell align="center">-</Cell>
      <Cell align="center">{formatMetric(totals.totalCustomers, "COLUMN", { noDecimals: true })}</Cell>
      <Cell align="center">{formatMetric(totals.totalProspects, "COLUMN", { noDecimals: true })}</Cell>
      <Cell align="center">{formatMetric(totals.penetration, "PERCENTAGE")}</Cell>
      <Cell align="center">{formatMetric(totals.driverInitial ?? 0, "COLUMN")}</Cell>
      <Cell align="center">{formatMetric(totals.driverFinal ?? 0, "COLUMN")}</Cell>
      <Cell align="center">{formatMetric(totals.headroom ?? 0, "COLUMN")}</Cell>
      <Cell align="center">{formatMetric(totals.headroomPercent ?? 0, "PERCENTAGE")}</Cell>
      <Cell align="center">{formatMetric(totals.increasedPenetration ?? 0, "PERCENTAGE")}</Cell>
      <Cell align="center">{formatMetric(totals.totalCustomersAfter ?? 0, "COLUMN", { noDecimals: true })}</Cell>
      <Cell align="center">{formatMetric(totals.totalDriverInitial ?? 0, "COLUMN")}</Cell>
      <Cell align="center">{formatMetric(totals.totalDriverFinal ?? 0, "COLUMN")}</Cell>
      <Cell align="center">{formatMetric(totals.totalHeadroom ?? 0, "COLUMN")}</Cell>
    </TableRow>
  );
};

const Cell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${colors.grey[400]}`,
  padding: theme.spacing(1.5),
  fontSize: "0.8rem",
  fontWeight: 600,
  backgroundColor: cruxyColors.amber.main,
  color: colors.text.primary,
  textAlign: "center",
}));

export default HeadroomTableTotalsRow;
